import { ActionContext } from 'vuex';

import { TApiResponse } from '@/common/types/response';
import { getLocalState } from '@/common/utils/store';

import { EXPIRED_INDICATOR_MUTATIONS_NAME } from './name';
import { TExpiredIndicatorState } from './types';

import links from '@/utils/links';
import request from '@/utils/request';

export async function fetchExpiredIndicator(context: ActionContext<TExpiredIndicatorState, unknown>) {
  const res: TApiResponse<TExpiredIndicatorState> = await request(
    context,
    {
      url: links.importAnalytics.indicatorLoadMonitoring.getExpiredIndicator,
      name: EXPIRED_INDICATOR_MUTATIONS_NAME.setHasExpiredIndicator,
    },
    {},
  );

  context.commit(
    getLocalState(EXPIRED_INDICATOR_MUTATIONS_NAME.setHasExpiredIndicator),
    res.success ? !!res.data?.hasExpiredIndicator : false,
  );
}
